import { purple } from "@ant-design/colors"
import { faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip } from "antd"
import { useState } from "react"
import ThemableButton from "../../Items/ThemableButton"
import SaveAsTemplateModal from "./SaveAsTemplateModal"

type Props = {
  workareaId: number
  disabled?: boolean
  type?: "default" | "link" | "text" | "primary" | "dashed" | undefined
  colorPrimary?: string
  addIcon?: boolean
}

const SaveAsTemplateButton = ({ workareaId, disabled, type, colorPrimary, addIcon }: Props) => {
  const [open, setOpen] = useState(false)

  return <>
    <Tooltip title={disabled ? "Please save this job before creating a template" : ""}>
      <ThemableButton
        type={type ?? "primary"}
        size="large"
        icon={addIcon ? <FontAwesomeIcon icon={faPuzzlePiece} /> : undefined}
        onClick={() => setOpen(true)}
        colorPrimary={colorPrimary ?? purple.primary}
        disabled={disabled}
      >
        Save as Template
      </ThemableButton>
    </Tooltip>
    <SaveAsTemplateModal workareaId={workareaId} open={open} onClose={() => setOpen(false)} />
  </>
}

export default SaveAsTemplateButton
